export const locale = {
  lang: 'ar',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "لوحة التحكم",
        BADGE: "2",
        ANALYTICS: "الإحصائيات",
        ECOMMERCE: "التجارة الإلكترونية",
           "description_en":"الوصف ( انجليزى )",
        "description_ar":"الوصف ( عربى )",
         "title_required":"العنوان مطلوب  ",
        "content_required":" المحتوى مطلوب",
                "enter_content_en":" أدخل المحتوى انجليزى ",
                "enter_content_ar":" أدخل المحتوى عربى ",
 "enter_description_en": "دخل المحتوى انجليزى",
        "enter_description_ar": "أدخل المحتوى عربى ",
        "logout":"تسجيل خروج ",
        "HOME": "الرئيسية ",
        "MIRACLE":" المعجزة ",
        "SAMPLE": "عينة ",
        "users": "المستخدمين",
        "list": "عرض",
        "add": "إضافة",
        "ads": "الإعلانات",
         "employees": "الموظفين",
         "Active":"نشط ",
          "inActive":"غير نشط",
          "id_number":"رقم الهوية",
          "nationality":"الجنسية",
          "city":"المدينة",
            "please_select_at_least_one_news": "يرجى اختيار خبر واحد على الأقل"
,
          "select_related_news": "اختر الأخبار ذات الصلة",
  // "related_news": "الأخبار ذات الصلة",
  "related_news_saved_successfully": "تم حفظ الأخبار ذات الصلة بنجاح",
  "error_saving_related_news": "حدث خطأ أثناء حفظ الأخبار ذات الصلة",
           "icon": "أيقونة",
  "description": "الوصف",
          "select_city":"اختر المدينة",
          "serial_number":"رقم العقد",
          "add_countries_btn":"اضافة دولة",
            "TEAM_MEMBERS": "أعضاء الفريق",
    "investors": "المستثمرين",
    "contracts": "العقود",
    "alerts": "التنبيهات",
    "terms": "الشروط",
      "alerts_list": "قائمة التنبيهات",
      "edit_job_title": "تعديل المسمى الوظيفي",
      "show": "عرض",
       "partner_information": "معلومات الشريك",
      "click_to_upload_logo": "انقر لتحميل الشعار",
      "click_to_upload_imageEmp":"انقر لتحميل صورة الموظف ",
      "no_imageEmp_uploaded":"الرجاء تحميل الصورة هنا ",
      "drag_drop_image": "أو قم بسحب الصورة وإفلاتها هنا",
      "recommended_size": "الحجم الموصى به: 120×70 بكسل",
      "remove": "إزالة",
      "partner_name_note": "سيُستخدم هذا الاسم في الواجهة الإنجليزية",
      "enter_full_url": "أدخل رابط الموقع الكامل بما في ذلك https://",
      "order": "الترتيب",
      "additional_details": "تفاصيل إضافية",
      "investor_detailss": "تفاصيل المستثمر",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
       "edit_investor": "تعديل بيانات المستثمر",
      "enter_name": "أدخل الاسم",
      "enter_email": "أدخل البريد الإلكتروني",
      "employee_id": "معرف الموظف",
      "enter_employee_id": "أدخل معرف الموظف",
      "password": "كلمة المرور",
      "enter_password": "أدخل كلمة المرور",
      "enter_phone": "أدخل رقم الجوال",
      "select_type": "اختر النوع",
      "select_employee":"اختر الموظف ",
      "client": "عميل",
      "driver": "سائق",
      "user_name":"اسم المستخدم ",
      "name_ar": "الاسم (بالعربية)",
      "enter_name_ar": "أدخل الاسم بالعربية",
      "name_en": "الاسم (بالإنجليزية)",
      "enter_name_en": "أدخل الاسم بالإنجليزية",
      "image": "الصورة",
      "save_changes": "حفظ التعديلات",
      "phone": "رقم الجوال",
      "type": "النوع",
      "image_preview":"معاينة الصورة",
      "status": "الحالة",
      "no_image_available": "لا توجد صورة متاحة",
      "loading_investor_details": "جارٍ تحميل تفاصيل المستثمر...",
      "characters_limit": "250 حرفًا",
      "partner_added_success": "تمت إضافة الشريك بنجاح!",
      "investors_list": "قائمة المستثمرين",
      "investor_name": "الاسم",
      "job_title": "المسمى الوظيفي",
        "add_job_title": "إضافة مسمى وظيفي",
      "job_title_name_en": "اسم المسمى الوظيفي (إنجليزي)",
      "enter_job_title_name_en": "أدخل اسم المسمى الوظيفي",
      "job_title_name_ar":"اسم المسمى الوظيفي",
      "enter_job_title_name_ar": "أدخل اسم المسمى الوظيفي",
      "add_job_title_btn": "إضافة المسمى الوظيفي",
      "job_title_list": "قائمة المسميات الوظيفية",
"job_title_list_description": "يمكنك عرض وإدارة جميع المسميات الوظيفية للموظفين بسهولة من مكان واحد.",
 "countries": " الدول",
 ", All rights Reserved":"جميع الحقوق محفوظة  ",
 "COPYRIGHT":"حقوق الطبع والنشر",
 "cities":"المدن",
 "cities_list":"قائمة المدن",
 "countries_name_en_required":"اسم الدولة انجليزى مطلوب",
 "countries_name_ar_required":"اسم الدولة عربى مطلوب",
 "enter_countries_name_en":"ادخل اسم الدولة انجلزى",
        "add_countries": " اضافة دولة",
      "countries_name_en": "اسم الدولة (إنجليزي)",
      "countries_title_name_en": "أدخل اسم  الوظيفي",
      "countries_name_ar": "اسم  الدولة (عربي)",
      "enter_countries_name_ar": "أدخل اسم  الدولة ",
      "cities_name_en_required":"اسم المدينة انجليزى مطلوب",
 "cities_name_ar_required":"اسم المدينة عربى مطلوب",
 "enter_cities_name_en":"ادخل اسم المدينة انجليزى",
        "add_cities": " اضافة المدينة",
      "cities_name_en": "اسم المدينة (إنجليزي)",
      "cities_title_name_en": "أدخل اسم  المدينة انجليزى ",
      "cities_name_ar": "اسم  المدينة (عربي)",
      "enter_cities_name_ar": "أدخل اسم  المدينة ",
      "countries_list": "قائمة الدول",
      "edit_countries":"تعديل الدولة",
"countries_list_description": "يمكنك عرض وإدارة جميع الدول بسهولة من مكان واحد.",
      "investor_image": "الصورة",
      "investor_type": "النوع",
            "employee_job_title": "المسمى الوظيفي",
      "investor_phone": "رقم الجوال",
      "employees_list": "قائمة الموظفين",
      "messages_platform_title": "منصة متكاملة لمتابعة الرسائل - عرض التفاصيل وتحديث الحالة بسلاسة",
      "role": "مستثمر",
      "replied": "تم الرد",
      "under_review": "قيد المراجعة",
      "not_replied": "لم يتم الرد",
      "message_title": "عنوان الرسالة",
      "communication_issue": "مشكلة فى التواصل",
      "message_content": " محتوى الرسالة ",
      "update_status": "تعديل الحالة",
      "employees_list_description": "يمكنك هنا تتبع وتصفية سجل الموظفين بالكامل.",
      "employee_email": "البريد الإلكتروني",
      "investor_email": "البريد الإلكتروني",
    "choose_user": "اختر المستخدم",
      "investor_actions": "الإجراءات",
      "date": "التاريخ",
"search_user": "ابحث عن المستخدم",
      "investor_details": "عرض",
        "send_notifications": "إرسال الإشعارات",
      "create_and_send_notifications_easily": "أنشئ وأرسل إشعاراتك بسهولة",
      "create_new_notification": "إنشاء إشعار جديد",
      "notification_title": "عنوان الإشعار",
      "notification_content": "محتوى الإشعار",
      "sent": "تم الإرسال",
      "recipients": "المستلمون",
      "all_users": "جميع المستخدمون",
       "notification_type": "نوع الإشعار",
      "investor": "مستثمر",
      "specific_user": " تحديد مستخدم",
      "featured_users": "المستخدمون المميزون",
      "new_users": "المستخدمون الجدد",
      "custom": "مخصص",
      "send_notification": "إرسال الإشعار",
      "investor_edit": "تعديل",
      "investor_delete": "حذف",
      "ADMIN_WELCOME": "مرحبًا بك في إدارة المعجزة",
      "END_CONTRACT": "إنهاء العقد",
      "CONFIRM_END_CONTRACT_TITLE": "إنهاء العقد؟",
      "CONFIRM_END_CONTRACT_TEXT": "سيبقى العقد والدفعات السابقة محفوظة، ولن تُسجل دفعات مستقبلية عليه.",
      "CONTRACT_ENDED_SUCCESSFULLY": "تم إنهاء العقد بنجاح",
      "entries": "المدخلات",
      "partners_list": "قائمة الشركاء",
      "partner_name": "الاسم",
      "write_short_description_partner": "اكتب وصفًا قصيرًا عن الشريك...",
      "partner_logo": "الشعار",
       "choose_status": "اختر الحالة",
      "select_status": "تحديد الحالة",
        "NOTIFICATION_SUCCESS_TITLE": "تم بنجاح", 
    "NOTIFICATION_SUCCESS_MESSAGE": "تم إرسال الإشعار بنجاح.",
    "NOTIFICATION_ERROR_TITLE": "خطأ",
    "NOTIFICATION_ERROR_MESSAGE": "فشل في إرسال الإشعار. يرجى المحاولة مرة أخرى.",
      "status_updated_successfully": "تم تحديث الحالة بنجاح",
      "failed_to_update_status": "فشل في تحديث الحالة",
      "failed_to_edit_countries":"فشل تعديل الدولة ",
      "countries_edited_successfully":"تم تعديل الدولة بنجاح",
      "partner_url": "الرابط",
      "partner_description": "الوصف",
      "search": "بحث",
       "add_partners": "إضافة الشركاء",
      "partner_add_button": "إضافة الشركاء",
       "edit_partners": "تحديث الشركاء",
      "partner_edit_button": "تحديث الشركاء",
      "select_nationality_first":"حدد الجنسية أولا ",
      "select_nationality":"حدد الجنسية",
      "cities_added_successfully":"تم اضافة المدينة بنجاح",
      // "failed_to_add_cities":"فشلت عملية إضافة المدينة",
      "chat":"المحادثات",
      "last_chat":"المحادثات السابقة",
            "Chat_dash":"لوحة متابعة المحادثات ",
      "Analysis_chat":"تحليل جميع محادثات الموظفين مع المستثمرين",
"Total_investors":"اجمالي المستثمرين",
"Total_messages":"اجمالى الرسائل ",
"Total_conversations":"اجمالى المحادثات",
"Total_employee":"اجمالى الموظفين",
"active":"نشط",
"detailes":"تفاصيل",

      "id": "المعرف",
      "analytics_overview": "نظرة عامة على التحليلات",
      "number_of_employees": "عدد الموظفين",
      "number_of_contracts": "عدد العقود",
      "number_of_projects": "عدد المشاريع",
        "contracts_list": "قائمة العقود",
"faq_title": "الأسئلة الشائعة",
"add_faq_list":"يمكنك الان اضافة عدد لا محدود من الأسئلة ",
 "add_employee": "إضافة موظف",
   "edit_employee": "تعديل بيانات  الموظف",
 
      "select_job_title": "اختر المسمى الوظيفي",
      "add_employee_description": "مرحبًا بك في نموذج إضافة موظف جديد. يرجى ملء المعلومات التالية بدقة.",
      "save": "حفظ",
      "faq_question_placeholder": "اكتب السؤال هنا...",
      "faq_answer_placeholder": "اكتب الإجابة هنا...",
      "faq_save_button": "حفظ التعديل",
      "link": "الرابط",
    "faq": "الأسئلة الشائعة",
     "employee": "الموظف",
         "cancel": "إلغاء",
         "updated_successfully":" تم تحديث البيانات بنجاح",
         "edit_faq":"تعديل الأسئلة والإجابات",
     "VISION_MISSIONtitle": "الرؤية",
     "add_Vision":"يمكنك الان اضافة وتعديل الرؤية  ",
      "loading_employee_details": "جارٍ تحميل تفاصيل الموظف...",
    "write_vision_here": "اكتب الرؤية هنا...",
    "write_goals_here": "اكتب الأهداف هنا...",
    "about_miracle": "من نحن ",
    "add_about_miracle":"يمكنك الان اضافة وتعديل محتوى صفحة من نحن ",
    "partners": "الشركاء",
    "add_contracts":"اضافة عقد",
    "add_contracts_list":" يمكنك اضافة عدد لا محدود من العقود  ",
          "welcome_to": "مرحبًا بك في"
,      "welcome_message": "مرحبًا بك في المعجزة! 👋"
,  "title_en": "عنوان النص (بالإنجليزية)",
 "profit_max": "الحد الأقصى للأرباح",
      "from_amount": "من",
      "to_amount": "إلى",
      "enter_title_en": "أدخل العنوان بالإنجليزية",
      "content_en": "المحتوى (بالإنجليزية)",
      "contract_details": "تفاصيل العقد",
      "additional_information": "معلومات إضافية",
      "company": "الشركة",
       "select_all": "تحديد الكل",
      "pay_selected": "دفع المحدد",
      "installments_selected": "الأقساط المحددة",
      "submit_payment": "إرسال الدفع",
      // "amount": "المبلغ المدفوع",
      // "payment_date": "تاريخ الدفع",
      // "transfer_file": "ملف التحويل"/,
      "enter_amount": "أدخل المبلغ",
      "view_current_pdf": "عرض ملف العقد الحالي",
"leave_empty_keep_pdf": "اتركه فارغاً للاحتفاظ بالملف الحالي",
       "contract_details_form": " تفاصيل الدفعات",
      "payment_data": "تاريخ الدفعة",
      "amount": "المبلغ",
      "responsible_employee":"الموظف المسئول",
 "no_investors_found":"لا يوجد مستثمرين ",
  "no_investors_for_employee":" لا يوجد مستثمر خاص بهذا الموظف ",
"Upcoming_payments":"الدفعات القادمة",
"payments":"الدفعات ",
"receipt_number": "رقم الإيصال",
      "view_pdf": "عرض ملف PDF"
,"transfer_file": "ملف التحويل",
      "no_file": "لا يوجد ملف",
      "contract_number": "رقم العقد", 
      "payment_date": "تاريخ الدفعة",
    "two_months": "شهرين",
"four_months": "أربعة أشهر",
"start_date": "تاريخ أول دفعة",
"start_date_required": "تاريخ أول دفعة مطلوب",
      "payment_method": "طريقة الدفع",
      "transfer_image": "صورة التحويل",
      "view_image": "عرض الصورة",
      "paid": "مدفوع",
      "unpaid": "غير مدفوع",
      "view_details": "عرض التفاصيل",
      "download_receipt": "تحميل الإيصال",
      "delete": "حذف",
"payments_list":"قائمة الدفعات التى تمت ",
"contract":"رقم العقد",
"Rs":"ر.س",
      "CONFIRM_DELETE_TITLE": "هل أنت متأكد؟",
      "CONFIRM_DELETE_TEXT": "لن تتمكن من التراجع عن هذا!",
      "YES_DELETE": "نعم، احذف!",
      "CANCEL": "إلغاء",
"addInvestor":"اضافة مستثمر",
 "add_new_payment": "إضافة دفعة جديدة",
 "failed_to_update_investor":"فشلت عملية تحديث المستثمر",
 "investor_updated_successfully":"تم تحديث بيانات المستثمر بنجاح",
 "employee_updated_successfully":"تم تحديث بيانات الموظف بنجاح",
 "failed_to_update_employee":"فشلت عملية التحديث ",
 "confirm_cancel":"هل حقا تريد الإلغاء",
      "payment_information": "معلومات الدفعة",
      "enter_payment_method": "أدخل طريقة الدفع",
      "account_number": "رقم الحساب",
      "enter_account_number": "أدخل رقم الحساب",
      "click_or_drag_image": "انقر أو اسحب الصورة هنا لرفعها",
"max_file_size": "الحد الأقصى لحجم الملف 5 ميجابايت (PNG, JPG, PDF)",

      "file_name": "اسم الملف",
      "size": "الحجم",
      "remove_image": "إزالة الصورة",
      "add_payment": "إضافة الدفعة",
       "monthly": "شهري",
      "user_id": "معرف المستخدم",
        "vision_ar": "الرؤية (عربي)",
      "vision_en": "الرؤية (إنجليزي)",
            "upload_pdf": "رفع ملف PDF"
,

"pdf": "ملف PDF",
"download_pdf": "تحميل PDF"
,
 "partner_description_ar": "وصف الشريك (AR)",
      "write_short_description_partner_ar": "اكتب وصفًا قصيرًا عن الشريك...",
      "goals_ar": "الأهداف (عربي)",
      "goals_en": "الأهداف (إنجليزي)",  "title_ar": " عنوان النص ( عربى ) ",
      "write_title_here_ar": "Write the Arabic title here...",
      
      "content_ar": "المحتوى ( عربى ) ",
      "write_content_here_ar": "Write the Arabic content here...",

      "write_title_here_en": "Write the English title here...",

      "write_content_here_en": "Write the English content here...",
    
      "next_installment_amount": "مبلغ القسط القادم",
      // "payment_date": "تاريخ الدفع",
      "payment_date_hijri": "تاريخ الدفع هجري",
      "no_data_available": "لا توجد بيانات متاحة",
      "selected": "محدد",
       
             "rs": "ر.س"
, "remove_current": "إزالة الحالي",
      "investment": "اجمالى الإستثمار"
,    "total": "العدد الكلي"
,
 "SUCCESS_TITLE": "مرحبًا بعودتك!",
  "INVESTOR_ADD_SUCCESS_TITLE": "تم إضافة المستثمر",
  "INVESTOR_ADD_SUCCESS_MESSAGE": "تمت إضافة المستثمر بنجاح.",

  "ERROR_TITLE": "خطأ",
  "GENERIC_ERROR": "حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى.",

  "FIELD_EMAIL_ERROR": "البريد الإلكتروني مطلوب أو غير صالح.",
  "FIELD_EMPLOYEE_ERROR": "حقل الموظف مطلوب.",
  "FIELD_CITY_ERROR": "حقل المدينة مطلوب.",
     "name_required": "الاسم مطلوب.",
           "no_auth_privacy_policy": "سياسة الخصوصية بدون توثيق",
           "content": "المحتوى",
    "name_min_length": "يجب أن يكون الاسم أطول من حرفين.",
    "email_required": "البريد الإلكتروني مطلوب.",
    "email_invalid": "الرجاء إدخال بريد إلكتروني صالح.",
    "phone_required": "رقم الجوال مطلوب.",
    "job_title_required": "المسمى الوظيفي مطلوب.",
    "password_required": "كلمة المرور مطلوبة.",
    "password_min_length": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
  "FIELD_NAME_ERROR": "الاسم مطلوب.",
  "FIELD_PHONE_ERROR": "رقم الجوال مطلوب أو غير صالح.",
  "FIELD_NATIONALITY_ERROR": "الجنسية مطلوبة.",
  "FIELD_IDENTITY_NUMBER_ERROR": "رقم الهوية مطلوب.",
    "SUCCESS_MESSAGE": "تم تسجيل الدخول بنجاح.",
    "FAILED_TITLE": "فشل تسجيل الدخول",
     "EMPLOYEE_ADD_SUCCESS_TITLE": "تم بنجاح",
      "show_alert": "عرض التنبيه",
      "details": "التفاصيل",
      "title": "العنوان",
      "message": "الرسالة",
      "okay": "حسناً",
    "EMPLOYEE_ADD_SUCCESS_MESSAGE": "تمت إضافة الموظف بنجاح!",
    "FIELD_JOB_TITLE_ERROR": "يرجى اختيار المسمى الوظيفي.",
    "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    "NETWORK_ERROR": "خطأ في الشبكة. تحقق من الاتصال بالإنترنت.",
  "loading_partner_data": "جارٍ تحميل بيانات الشريك...",
      "current_logo": "الشعار الحالي",
      "remove_new": "إزالة الجديد",
      "new_logo_preview": "معاينة الشعار الجديد",
      "no_logo_uploaded": "لم يتم رفع شعار",
      "english_interface_note": "سيُستخدم هذا الاسم في الواجهة الإنجليزية",
      "characters": "حروف",
      "quarterly": "ربع سنوي",
      "semi_annually": "نصف سنوي",
      "annually": "سنوي",
      "not_specified": "غير محدد",
      "location": "الموقع",
      "faqs": "الأسئلة الشائعة",
      "faqs_list": "قائمة الأسئلة الشائعة",
      "question": "السؤال",
      "answer": "الإجابة",
            "all_countries": "جميع الدول"
,
      "industry": "الصناعة",
      "last_activity": "آخر نشاط",
      "write_content_en": "اكتب المحتوى بالإنجليزية",
      "enter_title_ar": "أدخل العنوان بالعربية",
      "write_content_ar": "اكتب المحتوى بالعربية",
    "privacy_policy": "سياسة الخصوصية",
        "counselors": "المستشارين",
              "country": "الدولة"
,
          "signin_message": "يرجى تسجيل الدخول إلى حسابك  ",
     "Edit_Contract":"تعديل العقد ",
      "remember_me": "تذكرني",
      "sign_in": "تسجيل الدخول",
      "Ratio": "النسبة",
   "loadin":"  جاري تحميل المدن...",
    "saudi_phone_only": "يرجى إدخال رقم هاتف سعودي صحيح",
    "id_number_required": "رقم الهوية مطلوب",
    "id_number_format": "يجب أن يكون رقم الهوية 10 أرقام",
      
    "phone_invalid": "يرجى إدخال رقم هاتف صالح",
    "nationality_required": "الجنسية مطلوبة",
    payment_method_required: "طريقة الدفع مطلوبة",
payment_method_min_length: "طريقة الدفع يجب ألا تقل عن 3 أحرف",
payment_method_max_length: "طريقة الدفع يجب ألا تزيد عن 50 حرفًا",

account_number_required: "رقم الحساب مطلوب",
account_number_min_length: "رقم الحساب يجب ألا يقل عن 5 أحرف",
account_number_max_length: "رقم الحساب يجب ألا يزيد عن 30 حرفًا",
account_number_pattern: "صيغة رقم الحساب غير صحيحة",
    "paid_amount_required": "المبلغ المدفوع مطلوب",
    "paid_amount": "المبلغ المدفوع",
"enter_paid_amount": "أدخل المبلغ المدفوع",
file_type_not_supported: "نوع الملف غير مدعوم",
file_size_exceeded: "حجم الملف يتجاوز الحد المسموح",
transfer_image_required: "صورة التحويل مطلوبة",
"Add_Paid_Amount": "إضافة مبلغ مدفوع",
    "faq_added_successfully": "تمت إضافة السؤال بنجاح",
     "faq_updated_successfully": "تم تحديث السؤال بنجاح",
  "Paid_Amount": "المبلغ المدفوع",
  "Confirm": "تأكيد",
  "Transfer_Image": "صورة التحويل",
  "Cancel": "إلغاء",
  "PAID_SUCCESS": "تم إضافة المبلغ بنجاح",
    "failed_to_update_faq": "فشل في تحديث السؤال",
     "job_title_added_successfully": "تمت إضافة المسمى الوظيفي بنجاح",
          "countries_added_successfully": "تمت إضافة اسم الدولة بنجاح",
    "failed_to_add_countries": "فشل في إضافة اسم الدولة",
        "failed_to_add_cities": "فشل في إضافة اسم المدينة",

    "select_countries":"اختر الجنسية",
      "enter_id_number": "أدخل رقم الهوية"
, "NEWS_LIST": "قائمة الأخبار",
      "SECTORS_LIST": "قائمة القطاعات",
// "payment_date": "تاريخ الدفع",
"payment_date_required": "يرجى إدخال تاريخ الدفع"
, "NEWS": "الأخبار",
      "slug": "الرابط",
      "main_image": "الصورة الرئيسية",
      "published_at": "تاريخ النشر",
      "published": "منشور",
      "draft": "مسودة",
    "SECTORS": "القطاعات",
    "vision-ksa": "رؤية السعودية",
    "related_news": "الأخبار المرتبطة"
,
    "failed_to_add_job_title": "فشل في إضافة المسمى الوظيفي",
      "partner_id_missing": "معرّف الشريك غير موجود",
            "select_user": "اختر المستخدم",

            "Edit_Date": "تعديل التاريخ",
  "DATE_UPDATED_SUCCESS": "تم تعديل التاريخ بنجاح",
  "NO_INSTALLMENT_FOUND": "لا يوجد قسط"
  ,
       "contract_updated_successfully": "تم تحديث العقد بنجاح",
        "contract_type_added_successfully": "تمت إضافة نوع العقد بنجاح",
    "failed_to_update_contract": "فشل في تحديث العقد",
     "question_ar": "السؤال (عربي)",
      "question_en": "السؤال (إنجليزي)",
        "pdf_file": "ملف PDF"
,  "MENU.DASHBOARD.Edit_Date": "تعديل التاريخ"
,
       "body_ar": "محتوى الإشعار (AR)",
      "body_en": "محتوى الإشعار (EN)",
      "answer_ar": "الإجابة (عربي)",
          "notification_content_ar": "محتوى الإشعار (AR)",
          "notification_content_en": "محتوى الإشعار (En)",
       "notification_title_en": "عنوان الإشعار (EN)",
       "notification_title_ar": "عنوان الإشعار (Ar)",
"add_privacy_policy":"اضافة وتعديل  سياسة الخصوصية",
"mission":"الرسالة",
"edit_cities":"تعديل المدينة ",
"add_mission":"اضافة وتعديل الرسالة  ",
"terms_and_conditions":"الشروط والأحكام",
"add_terms_and_conditions":" اضافة الأحكام والشروط ",
      "answer_en": "الإجابة (إنجليزي)",
     "record_updated_successfully": "تم تحديث السجل بنجاح",
     "user_required": "يجب اختيار المستخدم",
      "contact_us": "اتصل بنا",
     
      "cities_edit_successfully":"تم تعديل المدينة بنجاح",
            "cities_add_successfully":"تم اضافة المدينة بنجاح",

      "contact_us_list": "قائمة اتصل بنا",
      "select_user_required": "يرجى اختيار المستخدم",
        "titlee": "حذف الحساب",
         "flag_true": "حسابك حالياً محذوف.",
    "flag_false": "حسابك حالياً مفعل.",
    "messagee": "بمجرد حذف حسابك، لن تتمكن من استعادته مرة أخرى.",
    "button": "حذف الحساب",
    "disabled": "ميزة حذف الحساب غير متاحة حالياً.",
    "confirm_title": "هل أنت متأكد؟",
    "confirm_message": "سيتم حذف حسابك نهائياً ولن تتمكن من استعادته.",
    "confirm": "نعم، احذف",
    "success": "تم حذف حسابك بنجاح.",
    "error": "حدث خطأ، برجاء المحاولة مرة أخرى.",
  
      "job_title_name_en_required": "المسمى الوظيفي بالإنجليزية مطلوب",
      "job_title_name_ar_required": "المسمى الوظيفي بالعربية مطلوب",
      
      "name_ar_required": "يرجى إدخال الاسم بالعربية",
   
      "name_en_required": "يرجى إدخال الاسم بالإنجليزية",
      "select_contract_type_required": "يرجى اختيار نوع العقد",
      "next": "التالي",
"prev": "السابق",
      "select_duration_required": "يرجى اختيار المدة",
       "DELETED_SUCCESSFULLY": "تم الحذف بنجاح",
  "SOMETHING_WENT_WRONG": "حدث خطأ ما",
      "enter_investment_amount_required": "يرجى إدخال مبلغ الاستثمار",
      "enter_investment_rate_required": "يرجى إدخال نسبة الاستثمار",
    "contract_type_required": "يجب اختيار نوع العقد",
    "duration_required": "مدة العقد مطلوبة",
    "investment_amount_required": "مبلغ الاستثمار مطلوب",
    
    "investment_rate_required": "نسبة الاستثمار مطلوبة",
    "reports": "التقارير",
     "add_sectors": "إضافة القطاعات",
      "edit_sectors": "تعديل القطاعات",
      "add_sectors_list": "قائمة إضافة القطاعات",
     "add_team_members": "إضافة أعضاء الفريق",
      "add_team_members_list": "قائمة إضافة أعضاء الفريق",
      "reports_list": "قائمة التقارير",
      "add_reports": "إضافة التقارير",
      "add_reports_list": "قائمة إضافة التقارير",
      "edit_news": "تعديل الخبر",
    "failed_to_update_record": "فشل في تحديث السجل",
    "missing_id": "معرّف السجل مفقود",
          "our_messages": "رسائلنا"
,      "our_messages_list": "قائمة رسائلنا",
      "team_members_list": "قائمة أعضاء الفريق",
"add_news": "إضافة خبر",
 "edit_reports": "تعديل التقارير",
      "add_news_list": "قائمة الأخبار",
       "edit_team_members": "تعديل أعضاء الفريق",
      "additional_images": "صور إضافية",
      "created_at": "تاريخ الإنشاء",
      "file": "ملف",
      "view": "عرض",
    "contract_id_missing": "معرّف العقد مفقود",
        "job_title_id_missing": "معرّف المسمى الوظيفي مفقود",
         "contract_added_successfully": "تمت إضافة العقد بنجاح",
    "fill_required_fields": "يرجى ملء جميع الحقول المطلوبة",
    "job_title_updated_successfully": "تم تحديث المسمى الوظيفي بنجاح",
    "failed_to_update_job_title": "فشل في تحديث المسمى الوظيفي",
    "fill_all_required_fields": "يرجى تعبئة جميع الحقول المطلوبة",
    "partner_updated_successfully": "تم تحديث بيانات الشريك بنجاح",
    "nationality_min_length": "يجب أن تكون الجنسية至少 حرفين",
    "city_required": "المدينة مطلوبة",
    "city_min_length": "يجب أن تكون المدينة至少 حرفين",
    "employee_required": "يرجى اختيار موظف",
     "question_required": "حقل السؤال مطلوب",
    "answer_required": "حقل الإجابة مطلوب",
    "partner_added_successfully": "تمت إضافة الشريك بنجاح",
  "something_went_wrong": "حدث خطأ ما",
    "image_required": "الصورة مطلوبة",
      "contract_type": "نوع العقد",
  //      "employee_updated_successfully": "تم تحديث الموظف بنجاح",
  // "failed_to_update_employee": "فشل في تحديث بيانات الموظف",
       "duration_months": "المدة (بالأشهر)",
      
      "investment_amount": "مبلغ الاستثمار",
      "investment_rate": "نسبة الاستثمار",
      "investment_rate_min":"نسبة الاستثمار ( من ) ",
      "investment_rate_max":"نسبة الاستثمار ( الى ) ",

      "profit_amount": "مبلغ الأرباح",
      "approved": "تمت الموافقة",
      "enter_user_id": "أدخل معرّف المستخدم",
      "select_contract_type": "اختر نوع العقد",
      "enter_duration": "أدخل المدة",
      "enter_investment_amount": "أدخل مبلغ الاستثمار",
      "enter_investment_rate": "أدخل نسبة الاستثمار",
      "enter_profit_amount": "أدخل مبلغ الأرباح",

"CONTRACT_TYPElist": "قائمة أنواع العقود",
      "CONTRACT_TYPEname_ar": "الاسم بالعربية",
      "CONTRACT_TYPEname_en": "الاسم بالإنجليزية",
      "pending": "قيد الانتظار",
      "rejected": "مرفوض",
        "stores_offers": "عروض المتاجر",
        "cancelation_reason": "سبب الإلغاء",
        "companies": "الشركات",
        "consulting": "الاستشارات",
        "categories": "الفئات",
        "services": "الخدمات",
        "tags": "العلامات",
        "articles": "المقالات",
        "offers": "العروض",
        "plantcards": "بطاقات النباتات",
    "analytics": "التحليلات",
        "Settings": "الإعدادات",
    "ShowDetails": "عرض التفاصيل",
    "TermsAndConditions": "الشروط والأحكام",
    "About": "حول",
    "Notifications": "الإشعارات",
    "Currencies": "العملات",
    "Countries": "الدول",
    "Countries_list":"قائمة الدول",
    "Cities": "المدن",
    "plans": "الخطط",
      "light": "الضوء",
      "root": "الجذر",
      "seed": "البذرة",
      "soil": "التربة",
      "stem": "الجذع",
      "counselorspayment": "دفع المستشارين",
      "OpenScreens": "الشاشات المفتوحة",
    "GanatakCommunity": "مجتمع جانتاك",
    "Paperform": "نموذج الورقة",
    "Sizes": "الأحجام",
    "Sliders": "المنزلقات",
    "error_adding_payment":"فشلت عملية الإضافة",
    "payment_added_successfully":"نجحت عملية الإضافة",
    //  "add_new_payment": "إضافة دفعة جديدة",
    //   "payment_information": "معلومات الدفعة",
    //   "payment_method": "طريقة الدفع",
    //   "enter_payment_method": "أدخل طريقة الدفع",
    //   "account_number": "رقم الحساب",
    //   "enter_account_number": "أدخل رقم الحساب",
    //   "transfer_image": "صورة التحويل",
    //   "click_or_drag_image": "انقر أو اسحب الصورة هنا",
    //   "max_file_size": "الحد الأقصى لحجم الملف: 5MB",
    //   "file_name": "اسم الملف",
    //   "size": "الحجم",
    //   "remove_image": "إزالة الصورة",
      // "add_payment": "إضافة الدفعة",
      "sending": "جاري الإرسال...",
      // "payment_added_successfully": "تم إضافة الدفعة بنجاح",
      // "error_adding_payment": "حدث خطأ أثناء إضافة الدفعة",
      "all_fields_required": "جميع الحقول",
      "are_required": "مطلوبة"



      },
      
 VALIDATION: {
    "name_required": "اسم الحقل مطلوب",
    "name_min_length": "يجب أن يكون الاسم至少 حرفين",
    "email_required": "البريد الإلكتروني مطلوب",
    "email_invalid": "يرجى إدخال بريد إلكتروني صحيح",
    "phone_required": "رقم الجوال مطلوب",
    "saudi_phone_only": "يرجى إدخال رقم هاتف سعودي صحيح",
    "id_number_required": "رقم الهوية مطلوب",
    "id_number_format": "يجب أن يكون رقم الهوية 10 أرقام",
    "nationality_required": "الجنسية مطلوبة",
    "nationality_min_length": "يجب أن تكون الجنسية至少 حرفين",
    "city_required": "المدينة مطلوبة",
    "city_min_length": "يجب أن تكون المدينة至少 حرفين",
    "employee_required": "يرجى اختيار موظف",
    "image_required": "الصورة مطلوبة",
     "payment_method_required": "طريقة الدفع مطلوبة",
    "payment_method_min_length": "طريقة الدفع يجب أن تحتوي على الأقل على حرفين",
    "payment_method_max_length": "طريقة الدفع يجب ألا تزيد عن 100 حرف",
    "account_number_required": "رقم الحساب مطلوب",
    "account_number_min_length": "رقم الحساب يجب أن يحتوي على الأقل على 5 أرقام",
    "account_number_max_length": "رقم الحساب يجب ألا يزيد عن 50 رقم",
    "account_number_pattern": "رقم الحساب يجب أن يحتوي على أرقام فقط",
    "transfer_image_required": "صورة التحويل مطلوبة",
    "file_type_not_supported": "نوع الملف غير مدعوم. الرجاء رفع صورة بصيغة JPEG, PNG, JPG, أو GIF",
    "file_size_exceeded": "حجم الملف كبير جداً. الحد الأقصى هو 5MB",
    // "payment_method_required": "طريقة الدفع مطلوبة",
    // "payment_method_min_length": "طريقة الدفع يجب أن تكون على الأقل حرفين",
    // "payment_method_max_length": "طريقة الدفع يجب ألا تزيد عن 100 حرف",
    // "account_number_required": "رقم الحساب مطلوب",
    // "account_number_min_length": "رقم الحساب يجب أن يكون على الأقل 5 أرقام",
    // "account_number_max_length": "رقم الحساب يجب ألا يزيد عن 50 رقماً",
    // "account_number_pattern": "رقم الحساب يجب أن يحتوي على أرقام فقط",
    // "transfer_image_required": "صورة التحويل مطلوبة",
    // "file_type_not_supported": "نوع الملف غير مدعوم. يرجى استخدام صورة (JPEG, PNG, JPG, GIF, WebP)",
  },
   "COMMON": {
    "required": "مطلوب",
    "optional": "اختياري",
    "success": "نجاح",
    "error": "خطأ",
    "loading": "جاري التحميل...",
    "submit": "إرسال",
    "cancel": "إلغاء",
    "back": "رجوع"
  },
   "CHAT": {
    "TITLE": "تفاصيل المحادثة",
    "LOADING": "جاري تحميل المحادثة...",
    "ERROR": "خطأ في تحميل المحادثة",
    "ONLINE": "متصل الآن",
    "FIRST_MESSAGE": "أول رسالة",
    "MESSAGES": "رسالة",
    "MESSAGES_PLURAL": "{{count}} رسائل",
    "SECURE_CHAT": "محادثة آمنة ومشفرة",
    "SENT": "تم الإرسال",
    "RECEIVED": "تم الاستلام",
    "IMAGE": "صورة",
    "TYPE_MESSAGE": "اكتب رسالتك هنا...",
    "SEND": "إرسال"
  },
  "DATE": {
    "TODAY": "اليوم",
    "YESTERDAY": "أمس"
  },

      USERS_SECTION: "العملاء",
      USERS: {
        LIST: "قائمة المستخدمين",
        ADD: "إضافة مستخدم"
      },
      PRODUCTS: {
        Title: "المنتجات",
        LIST: "قائمة المنتجات",
        AT_HOME: "منتجات في المنزل"
      },
      COUNSELORS: {
        Title: "المستشارين",
        LIST: "قائمة الاستشاريين",
        ADD: "إضافة استشاري"
      },
      STORES: {
        Title: "المتاجر",
        LIST: "قائمة المتاجر",
        ADD: "إضافة متجر"
      },
      STORES_OFFERS: {
        Title: "عروض المتاجر",
        LIST: "قائمة العروض"
      }, VOUCHER: {
        Title: "العروض الترويجية",
        TYPE: "أنواع العروض الترويجية",
        LIST: "قائمة العروض الترويجية"
      }, cancelation_reasons: {
        Title: "سبب الالغاء",
        LIST: "قائمة أسباب الإلغاء",
        ADD: "إضافة سبب"
      },
      COMPANIES: {
        Title: "الشركات",
        LIST: "قائمة الشركات",
        ARCHIVED: "الشركات المؤرشفة",
        "ADD": "إضافة شركة"
      },
      consulting: {
        Title: "الاستشارات",
        LIST: "قائمة الاستشارات",
      }, SERVICES: {
        Title: "الخدمات",
        LIST: "قائمة الخدمات",
        ADD: "إضافة خدمة"
      },
      SECTION: {
        Title: "الاقسام",
        LIST: "قائمة الاقسام",
        TYPES: "انواع القسائم",
        ADD: "إضافة قسم"

      },
      ARTICLES: {
        Title: "المقالات",
        LIST: "قائمة المقالات",
        Plant_groups: "المجموعات النباتية",
        ADD: "إضافة ",
        various: "مقالات زراعية متنوعة",
      },
      TAGS: {
        Title: "التاجات",
        LIST: "قائمة التاجات",
        ADD: "إضافة علامة"
      },
      offers: {
        Title: "العروض",
        LIST: "قائمة العروض",
        ADD: "إضافة عروض"
      },
      reasone_canceled: {
        Title: "سبب الالغاء",
        LIST: "قائمة ",
        ADD: "إضافة"
      },

      "PLANTCARDS": {
        "TITLE": "بطاقات النباتات",
        "LIST": "قائمة بطاقات النباتات",
        "ADD": "إضافة بطاقة نبات",
        "LEAVERSCOLOR": {
          "TITLE": "ألوان أوراق النباتات",
          "LIST": "قائمة ألوان أوراق النباتات",
          "ADD": "إضافة لون لأوراق النباتات"
        },
        "LEAVERSFORM": {
          "TITLE": "أشكال أوراق النباتات",
          "LIST": "قائمة أشكال أوراق النباتات",
          "ADD": "إضافة شكل لأوراق النباتات"
        },
        "FLOWERFORM": {
          "TITLE": "أشكال الأزهار",
          "LIST": "قائمة أشكال الأزهار",
          "ADD": "إضافة شكل للأزهار"
        },
        "FLOWERCOLOR": {
          "TITLE": "ألوان الأزهار",
          "LIST": "قائمة ألوان الأزهار",
          "ADD": "إضافة لون للأزهار"
        },
        "ENVIRONMENTLIGHT": {
          "TITLE": "إضاءة البيئة",
          "LIST": "قائمة إضاءة البيئة",
          "ADD": "إضافة إضاءة بيئة"
        },
        "ENVIRONMENTTEMP": {
          "TITLE": "درجة حرارة البيئة",
          "LIST": "قائمة درجات حرارة البيئة",
          "ADD": "إضافة درجة حرارة بيئة"
        },
        "ENVIRONMENHUMIDITY": {
          "TITLE": "رطوبة البيئة",
          "LIST": "قائمة رطوبة البيئة",
          "ADD": "إضافة رطوبة بيئة"
        },
        "REPRODUCTIONS": {
          "TITLE": "التكاثر",
          "LIST": "قائمة طرق التكاثر",
          "ADD": "إضافة طريقة تكاثر"
        },
        "PLANTCARDSOIL": {
          "TITLE": "أنواع التربة",
          "LIST": "قائمة أنواع التربة",
          "ADD": "إضافة نوع تربة"
        },

        


 

      }

    }
  
  }
}
